document.addEventListener('DOMContentLoaded', () => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const tracks = document.querySelectorAll('.benefit-marquee__track');
  if (!tracks.length) return;

  tracks.forEach((track) => {
    const firstSet = track.querySelector('.benefit-marquee__set');
    if (!firstSet) return;

    const speed = 30; // px per second
    let setWidth = firstSet.getBoundingClientRect().width;
    window.addEventListener('resize', () => {
      setWidth = firstSet.getBoundingClientRect().width;
    });

    let position = 0;
    let lastTime = null;

    function step(now) {
      if (lastTime === null) lastTime = now;
      const delta = (now - lastTime) / 1000;
      lastTime = now;

      if (setWidth > 0) {
        position -= speed * delta;
        if (Math.abs(position) >= setWidth) position += setWidth;
        track.style.transform = 'translateX(' + position + 'px)';
      }

      requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  });
});
